import $ from 'jquery';

export default function BlockTouch({blockTouch, setBlockTouch}) {
  return (
    <>
      <div
        className="block-touch"
        id="block-touch"
        style={{ display: blockTouch ? "flex" : "none" }}
      ></div>
      <div
        className="block-touch-exit exit"
        id="block-touch-exit"
        onClick={() => {
          $(`#block-touch, #block-touch-exit`).hide();
          setBlockTouch(false);
        }}
        style={{display:'none', zIndex:31000, position:'fixed'}}
      >
        <svg>
          <g style={{ stroke: "white", strokeWidth: "23%" }}>
            <line x1="20%" y1="20%" x2="80%" y2="80%"></line>
            <line x1="80%" y1="20%" x2="20%" y2="80%"></line>
          </g>
          ✖
        </svg>
      </div>
    </>
  );
}
